import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useStyles from './NoSearchResults.styles';
const NoSearchResults = (props) => {
    const { classes } = useStyles();
    const { searchInput } = props;
    return (_jsxs("p", { className: classes.title, children: ["Sorry, but there are no results for your search ", _jsx("span", { className: classes.searchText, children: `"${searchInput}"` })] }));
};
export default NoSearchResults;
